import * as React from 'react';

import MediaQuery from 'react-responsive';
import { ICalendarAppState } from '../../redux-state';
import { setToMobile } from '../../redux-state/actions/calendar-settings.actions';
import { connect } from 'react-redux';


interface DispatchToProps {
    setToMobile: () => void;
}

type ResponsiveProps = DispatchToProps;

export class MobileResponsiveBase extends React.Component<ResponsiveProps, any> {

    componentWillMount() {
        this.props.setToMobile();
    }

    /**
     * No need to render anything, since the lifecycle events handle that stuff.
     */
    render() {
        return null
    }
}

function mapDispatchToProps(dispatch): DispatchToProps {
    return {
        setToMobile: () => dispatch(setToMobile())
    }
}

export default connect<null, DispatchToProps>(null, mapDispatchToProps)(MobileResponsiveBase);